import { HELLOFLEX_CHECKBOX_CLASS } from '../Checkbox/Checkbox';
import { HELLOFLEX_ROUTE_LINK_CLASS } from './const';

const stopNavigationClasses: Array<string> = [
	'linkComponent',
	HELLOFLEX_CHECKBOX_CLASS,
	HELLOFLEX_ROUTE_LINK_CLASS,
	'tooltipButton',
];

export function allowNavEvent(e: React.MouseEvent<HTMLElement, React.MouseEvent>) {
	let targetTag = e.target as HTMLElement;

	while (targetTag !== e.currentTarget && e.currentTarget !== null) {
		for (let i = 0; i < stopNavigationClasses.length; i += 1) {
			const classList = targetTag?.classList;

			if (typeof classList === 'undefined' || classList.contains(stopNavigationClasses[i])) {
				return false;
			}
		}

		targetTag = targetTag.parentNode as HTMLElement;
	}

	return true;
}
